import { Stack, Typography } from "@mui/material";
import {
  borderOrange,
  borderStyle,
  defaultTransition,
  perelynPrimary,
  tinyGap,
} from "../../styles/consts";

interface RejectionReasonButtonProps {
  reason: string;
  isSelected: boolean;
  onClick: () => void;
}

export default function RejectionReasonButton({
  reason,
  isSelected,
  onClick,
}: RejectionReasonButtonProps) {
  return (
    <Stack
      onClick={onClick}
      sx={{
        flexDirection: "row",
        border: isSelected ? borderOrange : borderStyle,
        padding: tinyGap,
        width: "fit-content",
        alignItems: "center",
        transition: defaultTransition,
        "&:hover": {
          border: borderOrange,
          cursor: "crosshair",
          "& > *": {
            color: perelynPrimary,
          },
        },
      }}
    >
      <Typography
        sx={{
          transition: defaultTransition,
          color: isSelected ? perelynPrimary : undefined,
        }}
      >
        {reason}
      </Typography>
    </Stack>
  );
}
